exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Short media */\n.def-button-primary[data-v-5068b7d7] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n}\n@media only screen and (min-width: 768px) {\n.def-button-primary[data-v-5068b7d7] {\n    height: 50px;\n}\n}", ""]);

// exports
